// Module
var code = "<a data-bind=\"visible: ViewModel.DisplayValue, tooltip:{content: $parent._labels.PORTLET_SETTINGS}\" class=\"config\"></a>";
// Exports
export default code;